var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kun_loading48_container"},[_c('div',{staticClass:"custom-loader"})])
}]

export { render, staticRenderFns }